import type { ErrorReportInput } from 'helpers/formatErrorReport';
import { createGlobalState } from 'react-use';

export type GlobalErrorMessages = string | Array<{ key: string; message: string }>;

export type GlobalErrorState = {
  messages: GlobalErrorMessages;
  diagnostics?: ErrorReportInput;
};

export type GlobalErrorProp = GlobalErrorState | GlobalErrorMessages | undefined;

export const useGlobalError = createGlobalState<GlobalErrorProp>(undefined);

export type SetGlobalError = (errors: GlobalErrorProp) => void;

export const normalizeGlobalError = (value: GlobalErrorProp): GlobalErrorState | undefined => {
  if (value == null) return undefined;
  if (typeof value === 'string' || Array.isArray(value)) return { messages: value };
  return value;
};
